import useUser from './useUser'

const useIsUserLoggedIn = (): boolean => !!useUser()

export default useIsUserLoggedIn
